import VueSelectV4 from './components/Select.vue'
import mixins from './mixins/index.js'

export default VueSelectV4
export { VueSelectV4, mixins }
